/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
// ANCHOR Payloads
import { createCourseLecturer, createSpeaker } from './course';
import {
  IGetCourseInstructorsPayload,
  ICreateCourseInstructorPayload,
  IUpdateCourseInstructorStatusPayload,
  IGetCourseInstructorsCheckPayload,
  IGetCourseInstructorsCoursesPayload,
  IGetProviderInstructorsCheckPayload,
} from './payloads/course-invite';

// ANCHOR Results
import {
  ICourseInstructorResult,
} from './results/course-invite';

export async function getCourseInstructors(
  { courseId, token }: IGetCourseInstructorsPayload,
) {
  const { sdk } = await import('../axios/graphql');

  const { courseInstructor } = await sdk(token).GetCourseInstructorByCourseId({
    courseID: Number(courseId),
  });

  return courseInstructor as ICourseInstructorResult[];
}

export async function getCourseInstructorCourses(
  { token, userId }: IGetCourseInstructorsCoursesPayload,
) {
  const { sdk } = await import('../axios/graphql');

  const { courseInstructor } = await sdk(token).GetCourseInstructorCourses({
    userID: userId,
  });

  return courseInstructor.map(({ course }) => ({
    ...course,
    moduleCount: course?.moduleCount.aggregate?.count,
  }));
}

export async function getCourseInstructorCheck(
  { courseId, token, userId }: IGetCourseInstructorsCheckPayload,
) {
  const { sdk } = await import('../axios/graphql');

  const { courseInstructor } = await sdk(token).GetCourseInstructorCheck({
    courseID: Number(courseId),
    userID: userId,
  });

  return !!courseInstructor.length;
}

export async function getProviderInstructorCheck(
  { providerId, token, userId }: IGetProviderInstructorsCheckPayload,
) {
  const { sdk } = await import('../axios/graphql');

  const { courseInstructor } = await sdk(token).GetProviderInstructorCheck({
    providerID: providerId,
    userID: userId,
  });

  return !!courseInstructor.length;
}

export async function createCourseInstructor(
  { token, courseId, ...payload }: ICreateCourseInstructorPayload,
) {
  const { sdk } = await import('../axios/graphql');

  const { courseInstructor } = await sdk(token).CreateCourseInstructor({
    courseId: Number(courseId),
    userId: payload.userId,
    email: payload.email,
    description: payload.description,
  });

  if (payload.isPublic) {
    const speaker = await createSpeaker({
      token,
      userId: payload.userId,
      displayName: payload.displayName,
      displayPhotoUuid: payload.displayPhotoUuid,
      description: payload.description ?? '',
    });

    const speakerId = speaker?.id ?? '';

    await createCourseLecturer({
      token,
      courseId,
      speakerId,
    });
  }

  return courseInstructor;
}

export async function updateCourseInstructorStatus(
  { token, id, isActive }: IUpdateCourseInstructorStatusPayload,
) {
  const { sdk } = await import('../axios/graphql');

  const { courseInstructor } = await sdk(token).UpdateCourseInstructorIsActive({
    id,
    isActive,
  });

  return courseInstructor as ICourseInstructorResult;
}
